import React from 'react';
import { Link } from 'react-router-dom';
import 'animate.css';


export default () => (
	<div className='landing'>
		<div className='info'>
			<div class="overlay">
				<h2 id="first">New</h2>
				<h2>Wave</h2>
				<h2>Property</h2>
				<h2>Group</h2>
				<h3>Committed to Building a Future Where Every Canadian Has a Place to Call Home.</h3>

				<Link to="/contactpage" className="button1">
					BOOK YOUR CONSULTATION
				</Link>

			</div>
		</div>
	</div>
);
